
import { CONSTANTS } from "../constants";

export default {
  data: () => ({
    TIMELINE_DATA: CONSTANTS.OUR_JOURNEY_DATA,
    TEAM: CONSTANTS.TEAM,
    BANNER_DETAILS: CONSTANTS.ABOUT_BANNER_DETAILS,
  }),
  head() {
    return ({
      title: "About us | AiBuddha",
    });
  },
};
